/**
 * @module Main
 * 
 * @description En este fichero se define la configuración del sistema
 */

/* eslint-disable */
import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import router from './router'

import { initializeApp } from "firebase/app";
loadFonts()

const firebaseConfig = {
  apiKey: "AIzaSyBYvy4iDSx3zteLlHLoiOEdEgbWsqs86tk",
  authDomain: "eyesee-bccbb.firebaseapp.com",
  projectId: "eyesee-bccbb",
  storageBucket: "eyesee-bccbb.appspot.com",
  messagingSenderId: "365269255786",
  appId: "1:365269255786:web:d8584b88186c646602ac13"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

createApp(App).use(router)
  .use(vuetify)
  .mount('#app')
